// extracted by mini-css-extract-plugin
export default {"container":"CQ-z","title":"DQ-z","link":"EQ-z"};